import { FC, ReactNode } from "react";
import styles from "../../css/Generics.module.css";
import { useDarkModeContext } from "@/hooks/contextHooks/useDarkModeContext";

type Props = {
  size?: "small" | "medium" | "large";
  color?: string;
  weight?: "normal" | "bold" | "light";
  children: ReactNode;
};

export const Text: FC<Props> = ({
  size = "medium",
  color = "#201b41",
  weight = "normal",
  children,
}) => {
  const { isDarkMode } = useDarkModeContext();

  const dynamicColor = isDarkMode ? "#ffffff" : color;

  return (
    <div
      className={
        size === "small"
          ? styles.textSmall
          : size === "medium"
            ? styles.textMedium
            : styles.textLarge
      }
      style={{
        color: dynamicColor,
        fontWeight: weight,
        width: "fit-content",
      }}
    >
      {children}
    </div>
  );
};
